import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "select-avatar-popup" }
const _hoisted_2 = { class: "popup-main" }
const _hoisted_3 = { class: "popup-header" }
const _hoisted_4 = { class: "popup-content" }
const _hoisted_5 = { class: "avatar-list" }
const _hoisted_6 = ["onClick"]

import { ref, onMounted } from 'vue';
import { useUserStore } from '@/store';
import { queryAvatar } from '@/api';


export default {
  __name: 'SelectAvatar',
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const userStore = useUserStore()

const avatarList = ref([])
const activeAvatar = ref('')

onMounted(() => {
  queryAvatar().then(res => {
    avatarList.value = res.data || [];
  })
})

const updateAvatar = () => {
  userStore.modifyUserInfo({ avatar: activeAvatar.value })
  emit('onClose')
}

return (_ctx, _cache) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_popup = _resolveComponent("van-popup")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popup, {
      show: true,
      "close-on-click-overlay": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createVNode(_component_van_image, {
              class: "close-icon",
              src: require('@/assets/img/common/close.png'),
              onClick: _cache[0] || (_cache[0] = $event => (emit('onClose')))
            }, null, 8, ["src"]), [
              [_directive_audio, void 0, "close"]
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(avatarList.value, (item) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: "avatar-bg",
                  onClick: $event => (activeAvatar.value = item.avatar)
                }, [
                  _createVNode(_component_van_image, {
                    class: _normalizeClass(["avatar-img", { 'active': item.avatar === activeAvatar.value }]),
                    fit: "cover",
                    src: item.avatar
                  }, null, 8, ["class", "src"])
                ], 8, _hoisted_6)), [
                  [_directive_audio]
                ])
              }), 256))
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", {
              class: "confirm-btn",
              onClick: updateAvatar
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('common.confirm')), 1)
            ])), [
              [_directive_audio]
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

}